///<amd-module name="typeahead/core/logging/SuggestionEngagementLogger" />

import {CollectorTransport} from "typeahead/core/logging/CollectorTransport";
import {SuggestionEngagementMetric} from "typeahead/core/logging/SuggestionEngagementMetric";
import {ElementFocusedMessage} from "typeahead/core/message/ElementFocusedMessage";
import {InputValueEditedMessage} from "typeahead/core/message/InputValueEditedMessage";
import {SuggestionSelectedMessage} from "typeahead/core/message/SuggestionSelectedMessage";
import {SuggestionShownMessage} from "typeahead/core/message/SuggestionShownMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import {UserExitedMessage} from "typeahead/core/message/UserExitedMessage";
import {Suggestion} from "typeahead/core/Suggestion";
import {PackageType, TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

export class SuggestionEngagementLogger {

    protected lob: string;
    protected domElementId: string;
    protected isSuggestionShown: boolean = false;
    protected isSuggestionSelected: boolean = false;
    protected userTypedQuery: string = "";
    protected selectedSuggestion: Suggestion;
    protected displayText: string = "";
    protected activeESSTests: string[] = [];

    constructor() {
        // Input element focused
        TypeaheadMessage.subscribe(
            ElementFocusedMessage.getTopic(), (topic: string, message: ElementFocusedMessage) => {
                this.lob = message.getContext().lob;
                this.domElementId = message.getDomElementId();
                this.displayText = message.getElementValue();
            },
        );

        // Suggestions displayed
        TypeaheadMessage.subscribe(
            SuggestionShownMessage.getTopic(), (topic: string, message: SuggestionShownMessage) => {
                this.isSuggestionShown = true;
                this.activeESSTests.push(message.getActiveESSTests());
            },
        );

        // UserEdit or Suggestion deselected
        TypeaheadMessage.subscribe(
            InputValueEditedMessage.getTopic(), (topic: string, message: InputValueEditedMessage) => {
                this.lob = message.getLob();
                this.domElementId = message.getDomElementId();
                this.isSuggestionSelected = false;
                this.userTypedQuery = message.getNewInputValue();
                this.displayText = message.getNewInputValue();
                this.selectedSuggestion = undefined;
            },
        );

        // Suggestion selected
        TypeaheadMessage.subscribe(
            SuggestionSelectedMessage.getTopic(),
            (topic: string, message: SuggestionSelectedMessage) => {
                this.lob = message.getLob();
                this.selectedSuggestion = message.getSuggestion();
            },
        );

        TypeaheadMessage.subscribe(
            UserExitedMessage.getTopic(),
            (topic: string, message: UserExitedMessage) => {
                if (this.domElementId) {
                    this.lob =
                        ($("#" + this.domElementId).attr("data-mask") === "4096") ? "DISCOVER" : this.lob;
                    this.emitMetric();

                    // Reset logger state
                    this.domElementId = undefined;
                    this.lob = undefined;
                    this.isSuggestionShown = false;
                    this.isSuggestionSelected = false;
                    this.userTypedQuery = "";
                    this.displayText = "";
                    this.selectedSuggestion = undefined;
                    this.activeESSTests = [];
                }
            },
        );
    }

    protected updatePackageType(): void {
        let getPackageTypeString = (packageType): string => {
            switch (packageType) {
                case PackageType.FlightHotelCar:
                    return "FHC";
                case PackageType.HotelCar:
                    return "HC";
                case PackageType.FlightCar:
                    return "FC";
                case PackageType.FlightHotel:
                    return "FH";
                default:
                    return "-";
            }
        };

        let packageType: PackageType = TypeaheadUtils.getPackageType();
        if (packageType !== PackageType.Unknown) {
            this.lob = "PACKAGES:" + getPackageTypeString(packageType);
        }
    }

    protected removeDuplicateESSTests(): void {
        let tempTests: string[] = [];
        for (let tests of this.activeESSTests) {
            if (typeof tests === "string" && tests.length > 0) {
                    tempTests = tempTests.concat(tests.split("|"));
            }
        }
        tempTests = tempTests.sort()
            .filter( (item, pos, ary): boolean => {
                    return !pos || item !== ary[pos - 1];
            });
        while (tempTests.indexOf("") === 0) {
            tempTests.shift();
        }
        this.activeESSTests = tempTests;
    }

    protected emitMetric(): void {
        this.updatePackageType();
        this.removeDuplicateESSTests();
        new CollectorTransport().log(new SuggestionEngagementMetric(
            this.lob,
            this.domElementId,
            this.userTypedQuery,
            this.displayText,
            this.isSuggestionShown,
            this.selectedSuggestion,
            this.activeESSTests.join("|")));
    }
}
